import { Button, Input } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { IFilterProps } from "./Interfaces";

const Filter: React.FC<IFilterProps> = ({
  setSelectedKeys,
  confirm,
  clearFilters,
  selectedKeys,
}) => {
  const [value, setValue] = useState<string>("");

  useEffect(() => {
    if (selectedKeys.length > 0) {
      setValue(selectedKeys.join(" ,"));
    }
  }, [selectedKeys]);

  const resetInputValue = useCallback(() => {
    setValue("");
    if (clearFilters) {
      clearFilters();
    }
  }, [clearFilters]);

  const onHandleSearch = useCallback(() => {
    confirm();
  }, [confirm]);

  const controlButtons = useMemo(
    () => (
      <div className="button-group table-filter__button-group">
        <Button
          size="small"
          type="text"
          className="button-group__button"
          disabled={!value.trim()}
          onClick={onHandleSearch}
        >
          <SearchOutlined />
        </Button>
        <Button
          size="small"
          type="text"
          disabled={!value}
          onClick={resetInputValue}
          className="button-group__button"
        >
          <CloseOutlined />
        </Button>
      </div>
    ),
    [onHandleSearch, resetInputValue, value]
  );

  const onInputChange = useCallback(
    (event) => {
      const string = event.target.value;

      setSelectedKeys(string ? [string.trim()] : []);
      setValue(string);
    },
    [setSelectedKeys]
  );

  return (
    <div className="table-filter">
      <Input
        addonAfter={controlButtons}
        size="small"
        onChange={onInputChange}
        value={value}
        onPressEnter={onHandleSearch}
      />
    </div>
  );
};

export default Filter;
